<template>
    <div class="container" style="background:none;">
    <BaseLoading v-if="loading"></BaseLoading>
    <UgoForm
        v-if="!loading && !error"
        style="background:none"
        ref="form"
        :form="formDef"
        :value="value"
        :editable="!as_view && editable"
        :as_view="as_view"
        :old="old"
        :design="design"
        :acl="config.acl"
        @input="handleInput"
    />
    <div class="flex-wrap flex-center container" v-if="error">{{ error }}</div>
    </div>
  </template>

<script>
import UgoForm from '../index.vue';
import defaultValueMixin from '../mixins/default-value';
import valueDefMixin from '../mixins/value-def';
import asViewMixin from '../mixins/as-view';
import { getCachedFormDef, loadRemoteFormDef } from '../remote-form-def-cache';
export default {
  mixins: [defaultValueMixin, valueDefMixin, asViewMixin],
  cname: '内嵌表',
  corder: 81,
  icon: 'biaoge',
  components: {
    UgoForm,
  },
  data() {
    return {
      error: '请选择数据模型(model)',
      loading: false,
      formDef: {},
    };
  },
  watch: {
    'config.model': {
      handler(v) {
        if (v) {
          this.getRemoteData();
        } else {
          this.error='请选择数据模型';
        }
      },
      deep: true,
    },
  },
  props: {
    fkey: {
      type: String,
    },
    design: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Object,
    },
    fields: {
      type: Array,
      default: ()=>([]),
    },
    label: {
      type: String,
    },
    old: {
    },
    model: {
      type: Object,
      default: ()=>({}),
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    old: {
      type: Object,
      default: ()=>({}),
    },
    editable: {
      type: Boolean,
    },
    config: {
      type: Object,
      default: ()=>({}),
    },

  },
  mounted() {
    if (this.config && this.config.model && (!this.formDef || !this.formDef.id)) {
      this.getRemoteData();
    }
  },
  properties: [
    {
      label: '数据模型',
      key: 'model',
      control: 'Select',
      option: {
        valueKey: 'key',
        getters: 'session/models',
      },
    }, {
      label: '可见性',
      key: 'acl',
      control: 'PermissionSelect',
    },

  ],
  methods: {
    getValueDef() {
      return this.valueDefNestedForm();
    },
    handleInput(e) {
      this.$emit('input', e);
    },
    validate() {
      const form = this.$refs.form;
      console.log('form', this.$refs, form);

      return form.validate();
    },
    getUpdateData(e) {
      const data = this.$refs.form.getUpdateData();
      if (data) {
        delete data.id;
        return data;
      }
    },

    getRemoteData() {
      const modelId = this.config.model;
      const view = this.view || 'editor';
      const cached = getCachedFormDef(modelId, view);
      if (cached) {
        this.formDef = cached;
        this.error = '';
        this.loading = false;
        return;
      }
      this.loading = true;
      loadRemoteFormDef({
        store: this.$store,
        api: this.$api,
        modelId,
        view,
      }).then((def) => {
        this.formDef = def;
        this.error = '';
      }).catch((e) => {
        this.error = e ? e.message : '加载错误';
      }).finally(() => {
        this.loading = false;
      });
    },

  },

  initModel(obj) {
    obj.config = {

    };
    return obj;
  },
};
</script>

  <style lang="less" scoped>

  </style>
